import styled from 'styled-components';

import { colors, spacing } from 'ui/theme';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { SortingContextProvider } from 'utils/contexts/sorting';

import { TableColumn } from './constants';
import { Table } from '../../../../components/table';
import { MessageTypeRows } from './MessageTypeRows';

const COLUMNS = [
  { id: TableColumn.messageType, width: '1fr' },
  { id: TableColumn.subscriptionPolicy, width: '1fr' },
  { id: TableColumn.status, width: '1fr' },
  { id: TableColumn.subscriptionAction, width: 'min-content' },
];

const Wrapper = styled.div`
  border-top: ${spacing.single} solid ${colors.grey15};
`;

type MessageTypesTableProps = {
  channelId: number;
};

export const MessageTypesTable = ({ channelId }: MessageTypesTableProps) => (
  <SortingContextProvider
    namespace={`channel-${channelId}`}
    defaultSortDirection={SORT_DIRECTIONS.ASCENDING}
    defaultSortField={TableColumn.messageType}
  >
    <Wrapper>
      <Table columns={COLUMNS}>
        <MessageTypeRows channelId={channelId} />
      </Table>
    </Wrapper>
  </SortingContextProvider>
);
